import { makeStyles } from '@map/theme';
import { oneTimeCodeValidator } from '@map/validators/user';
import { Typography } from '@mui/material';
import { Form } from '@shared/lib/form';
import { SubmitButton, SubmitFunction } from '@shared/lib/form/Form';
import Yup from '@shared/lib/yupWithCustomValidations';
import { ComponentProps, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormOneTimeCodeField } from '../formControls/controlled';
import Resender from './Resender';

const useStyles = makeStyles(({ spacing }) => ({
  field: {
    margin: spacing(8, 0, 6),
  },
}));

const validationSchema = Yup.object({ phoneVerificationCode: oneTimeCodeValidator.notBlank() });

const initialValues = {
  phoneVerificationCode: '',
};

type Props = ComponentProps<typeof Resender> & {
  onSubmit: SubmitFunction<{ phoneVerificationCode: string }>;
};
const PhoneVerificationForm = ({ onSubmit, phone, scope, children }: Props) => {
  const { classes } = useStyles();
  const messageValues = useMemo(() => ({ phone_number: <strong>{phone}</strong> }), [phone]);

  return (
    <>
      {children || (
        <Typography variant="body2" align="center">
          <p>
            <FormattedMessage id="phone_number_verification.message_sent" values={messageValues} />
          </p>
          <p>
            <FormattedMessage id="phone_number_verification.enter_code_instructions" />
          </p>
        </Typography>
      )}
      <Form initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
        <div className={classes.field}>
          <FormOneTimeCodeField name="phoneVerificationCode" />
        </div>

        <SubmitButton fullWidth={true} type="submit" size="medium">
          <FormattedMessage id="registration.next" />
        </SubmitButton>
        <Resender phone={phone} scope={scope} />
      </Form>
    </>
  );
};

export default PhoneVerificationForm;
